import { render } from "./RoadMap.vue?vue&type=template&id=0fd7789a&scoped=true"
import script from "./RoadMap.vue?vue&type=script&lang=js"
export * from "./RoadMap.vue?vue&type=script&lang=js"

import "./RoadMap.vue?vue&type=style&index=0&id=0fd7789a&lang=scss&scoped=true"

import exportComponent from "/Users/josue/Documents/projects/wwv/dapp/werewolfvalley/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd7789a"]])

export default __exports__